import React from "react";

const Container = ({ children, className }) => {
  return (
    <div className={`w-full bg-white ${className || ""}`}>
      <div className="mx-auto w-full max-w-[1536px]">{children}</div>
    </div>
  );
};

export default Container;
